module.exports = {
    "All": "Tous",
    "Recipient only": "Seulement au destinataire",
    "Nobody": "Personne",
    "Put on hold": "Mettre en attente"
};


// WEBPACK FOOTER //
// ./src/l10n-messages/fr/virtual_gifts.js